/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/event.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PermissionsSubject
 */
export interface PermissionsSubject {
    /**
     * 
     * @type {string}
     * @memberof PermissionsSubject
     */
    kind?: string;
    /**
     * 
     * @type {string}
     * @memberof PermissionsSubject
     */
    name?: string;
}

export function PermissionsSubjectFromJSON(json: any): PermissionsSubject {
    return PermissionsSubjectFromJSONTyped(json, false);
}

export function PermissionsSubjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): PermissionsSubject {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'kind': !exists(json, 'kind') ? undefined : json['kind'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function PermissionsSubjectToJSON(value?: PermissionsSubject | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'kind': value.kind,
        'name': value.name,
    };
}

